import React from 'react'
import { Link } from 'react-router-dom'

const RoutePath=(props)=>{
  return(
    <div className="route">
      <Link to={`/categorias/${props.categoryUrl}`}>{`/${props.category}`}</Link>
      {
        props.subCategory &&
        <Link to={`/categorias/${props.categoryUrl}/${props.subCategoryUrl}`}>{`${props.subCategory}`}</Link>
      }
      {
        props.product &&
        <Link to='#'>{`${props.product}`}</Link>
      }
    </div>
  )
}

export default RoutePath
